// Generated by CoffeeScript 2.7.0
var CheckBox;

import Base from './base.js';

import Optionable from './concerns/optionable.js';

import {
  FieldOption,
  FieldOptionProxy
} from '../field_option.js';

export default CheckBox = (function() {
  class CheckBox extends Base {
    static resolveTypedAttributes(attributes, _specified_attributes, _from_field_type) {
      attributes.options = attributes.options_attributes || [
        {
          value: '新选项'
        }
      ];
      delete attributes.options_attributes;
      return attributes;
    }

    constructor(attrs = {}, logic_settings = {}, fieldable) {
      var options, ref;
      super(attrs, logic_settings, fieldable);
      options = this.id || (!((ref = attrs.settings) != null ? ref.callback_url : void 0)) ? attrs.options : [];
      this._makeOptions(options, attrs.other_option, attrs.settings);
    }

    getDisappearedFieldIdsOnInit() {
      return _.pluck(this.logic_rule, 'field_ids');
    }

    generateOtherOptionProxy(value) {
      if (this.hasOtherOption) {
        return new FieldOptionProxy(this.otherOption, value);
      }
    }

    toJSON() {
      var field;
      field = super.toJSON();
      field.options_attributes = _.map(this.options, function(option, index) {
        option.position = index;
        return option.toJSON();
      });
      return _.omit(field, 'options');
    }

  };

  CheckBox.setAttributes(['other_option', 'other_option_entries_count', 'options', 'other_option_valid_hit_count']);

  CheckBox.prototype.availableLayouts = ['list', 'inline', 'select'];

  return CheckBox;

}).call(this);

CheckBox.assemble(Optionable);
